<div class="login-container">
  <div class="login-card">
    @if (isLoading) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    <div class="logo-container">
      <h2 class="logo-text">NeoDiary</h2>
    </div>
    <h1>Klinikportal</h1>

    @if (currentView !== 'register') {
      <div class="info-box">
        <p>Um die Zugangsdaten für das Klinikportal zu erhalten, musst du deine Klinik registrieren.</p>
        <button mat-raised-button color="primary" class="register-btn" (click)="showRegister()">Registrieren</button>
      </div>
    }

    @if (currentView === 'login') {
      <form [formGroup]="loginData" (ngSubmit)="submitLogin()" (submit)="$event.preventDefault()" novalidate>
        <mat-form-field appearance="fill" color="accent">
          <mat-label>E-Mail</mat-label>
          <input matInput formControlName="email" type="email" autocomplete="email">
          @if (loginData.get('email')?.hasError('email')) {
            <mat-error>Bitte gib eine gültige E-Mail-Adresse ein</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="fill" color="accent">
          <mat-label>Passwort</mat-label>
          <input matInput formControlName="password" [type]="hide ? 'password' : 'text'" autocomplete="current-password">
          <mat-icon matSuffix class="clickable" (click)="hide = !hide">
            {{ hide ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </mat-form-field>

        @if (errorMessage) {
          <div class="error-message">{{ errorMessage }}</div>
        }

        <div class="form-buttons-container">
          <button mat-button type="button" class="forgot-password" (click)="showResetRequest()">
            Passwort vergessen?
          </button>
          <button mat-raised-button color="primary" type="submit" [disabled]="loginData.invalid || isLoading">
            Anmelden
          </button>
        </div>
      </form>

    }

    @if (currentView === 'reset-request') {
      <h2>Passwort zurücksetzen</h2>
      <form [formGroup]="resetRequestForm" (ngSubmit)="submitResetRequest()" (submit)="$event.preventDefault()" novalidate>
        <mat-form-field appearance="fill" color="accent">
          <mat-label>E-Mail</mat-label>
          <input matInput formControlName="email" type="email" autocomplete="email">
          @if (resetRequestForm.get('email')?.hasError('email')) {
            <mat-error>Bitte gib eine gültige E-Mail-Adresse ein</mat-error>
          }
        </mat-form-field>

        <button mat-raised-button color="primary" type="submit" [disabled]="resetRequestForm.invalid || isLoading">
          Passwort zurücksetzen
        </button>

        <div class="dialog-actions">
          <button mat-button type="button" class="secondary-button" (click)="showLogin()">
            Zurück zum Login
          </button>
        </div>
      </form>
    }

    @if (currentView === 'reset-info') {
      <h2>E-Mail versendet</h2>
      <p class="info-text">
        Wenn die angegebene E-Mail-Adresse bei uns registriert ist, erhältst du in Kürze eine Nachricht mit weiteren Anweisungen zum Zurücksetzen deines Passworts.
      </p>
      <div class="dialog-actions">
        <button mat-button type="button" class="secondary-button" (click)="showLogin()">
          Zurück zum Login
        </button>
      </div>
    }

    @if (currentView === 'register') {
      <h2>Klinik registrieren</h2>
      <form [formGroup]="registerForm" (ngSubmit)="submitRegister()" (submit)="$event.preventDefault()" novalidate>
        <mat-form-field appearance="fill" color="accent">
          <mat-label>Name der Klinik/Institution</mat-label>
          <input matInput formControlName="clinicName">
        </mat-form-field>

        <mat-form-field appearance="fill" color="accent">
          <mat-label>Name Ansprechperson</mat-label>
          <input matInput formControlName="contactName">
        </mat-form-field>

        <mat-form-field appearance="fill" color="accent">
          <mat-label>E-Mail-Adresse der Ansprechperson</mat-label>
          <input matInput formControlName="contactEmail" type="email">
          @if (registerForm.get('contactEmail')?.hasError('email')) {
            <mat-error>Bitte gib eine gültige E-Mail-Adresse ein</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="fill" color="accent">
          <mat-label>Telefonnummer Ansprechperson</mat-label>
          <input matInput formControlName="contactPhone" type="tel">
        </mat-form-field>

        <mat-form-field appearance="fill" color="accent">
          <mat-label>Kommentar oder Nachricht</mat-label>
          <textarea matInput formControlName="comment" rows="3"></textarea>
        </mat-form-field>

        <mat-checkbox formControlName="privacyConsent" color="primary">
          Ich stimme der Verarbeitung meiner Daten gemäß der
          <a href="https://neodiary.app/datenschutz" target="_blank">Datenschutzerklärung</a> zu.
        </mat-checkbox>

        <button mat-raised-button color="primary" type="submit"
          [disabled]="registerForm.invalid" class="register-submit-btn">
          Registrierung absenden
        </button>

        <div class="dialog-actions">
          <button mat-button type="button" class="secondary-button" (click)="showLogin()">
            Zurück zum Login
          </button>
        </div>
      </form>
    }

  </div>
  <img src="assets/images/Baerchen_winkt.png" alt="NeoDiary Maskottchen" class="corner-bear"
       width="288" height="419" loading="lazy" decoding="async">
</div>
